import React from 'react';
import { Box, Paper, Typography } from '@mui/material';

const TickIcon = ({ size }) => (
  <img
    src="https://assets.askhippo.co.za/Icons/common/Check-Square.svg"
    alt="tick"
    width={size}
    height={size}
    style={{ flex: `0 0 ${size}px` }}
  />
);

export default function AvailabilityBubble({
  variant = 'success', // 'success' | 'unavailable' | 'error'
  addressLine,
  avatarSrc,
  tailOffset = 0,
  tailSize = 14,
  isMobile = false,
  titleSuccess = '**Awesome!** Fibre is available at this address.',
  titleUnavailable = '**Sorry!** Fibre is not available at this address.',
  titleError = '**Hmm…** we could not verify availability right now.',
}) {
  const title =
    variant === 'success'
      ? titleSuccess
      : variant === 'unavailable'
        ? titleUnavailable
        : titleError;

  const containerWidth = isMobile ? '45vw' : 345;
  const containerHeight = isMobile ? 185 : 200.5;
  const avatarSize = isMobile ? 48 : 70;
  const tail = isMobile ? 10 : tailSize;
  const fontTitle = isMobile ? '1rem' : '1.5rem';
  const fontAddress = isMobile ? '0.75rem' : '0.875rem';
  const fontFibre = isMobile ? '0.875rem' : '1rem';
  const leftMargin = isMobile ? '12px' : '19px';

  return (
    <Paper
      elevation={6}
      sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -60%)',
        width: containerWidth,
        height: containerHeight,
        borderRadius: '16px',
        boxShadow: '0px 12px 24px -4px rgba(22,47,59,0.12)',
        backgroundColor: '#fff',
        pointerEvents: 'none',
        overflow: 'visible',
        px: 0,
        '&::after': {
          content: '""',
          position: 'absolute',
          left: `calc(50% + ${tailOffset}px)`,
          transform: 'translateX(-50%) rotate(45deg)',
          width: `${tail}px`,
          height: `${tail}px`,
          background: '#fff',
          bottom: `-${tail / 2 - 0.5}px`,
          borderBottomLeftRadius: '3px',
          filter: 'drop-shadow(0px 6px 12px rgba(22,47,59,0.12))',
        },
      }}
    >
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: `${avatarSize}px 1fr`,
          gridTemplateRows: 'auto auto auto',
          columnGap: isMobile ? '6px' : '10px',
          position: 'relative',
          paddingRight: '5px',
        }}
      >
        <Box
          component="img"
          src={avatarSrc}
          alt="avatar"
          sx={{
            gridColumn: '1 / 2',
            gridRow: '1 / 2',
            width: avatarSize,
            height: avatarSize,
            objectFit: 'contain',
            position: 'absolute',
            top: isMobile ? '8px' : '10px',
            left: isMobile ? '6px' : '7px',
          }}
        />

        <Typography
          sx={{
            gridColumn: '2 / 3',
            gridRow: '1 / 2',
            mt: isMobile ? '8px' : '10px',
            fontFamily: 'Inter, sans-serif',
            fontWeight: 400,
            fontSize: fontTitle,
            lineHeight: isMobile ? '1.25rem' : '1.75rem',
            letterSpacing: '-0.03em',
            color: '#162F3B',
          }}
        >
          {title.split(/(\*\*[^*]+\*\*)/g).map((part, i) =>
            /^\*\*[^*]+\*\*$/.test(part) ? (
              <strong key={i} style={{ fontWeight: 700 }}>
                {part.slice(2, -2)}
              </strong>
            ) : (
              <span key={i}>{part}</span>
            )
          )}
        </Typography>

        {addressLine && (
          <Typography
            sx={{
              gridColumn: '1 / 3',
              gridRow: '2 / 3',
              mt: isMobile ? '4px' : '10px',
              ml: leftMargin,
              maxWidth: isMobile ? '70%' : '259px',
              fontFamily: 'Inter, sans-serif',
              fontWeight: 400,
              fontSize: fontAddress,
              lineHeight: isMobile ? '1rem' : '1.25rem',
              letterSpacing: '-0.002em',
              color: '#162F3B',
            }}
          >
            {addressLine}
          </Typography>
        )}

        {variant === 'success' && (
          <Box
            sx={{
              gridColumn: '1 / 3',
              gridRow: '3 / 4',
              display: 'flex',
              alignItems: 'center',
              gap: isMobile ? 0.5 : 0.75,
              ml: leftMargin,
              mt: isMobile ? '4px' : '8px',
            }}
          >
            <TickIcon size={isMobile ? 18 : 24} />

            <Typography
              sx={{
                fontFamily: 'Inter, sans-serif',
                fontWeight: 400,
                fontSize: fontFibre,
                lineHeight: isMobile ? '1.25rem' : '1.5rem',
                letterSpacing: '-0.002em',
                color: '#162F3B',
              }}
            >
              Fibre
            </Typography>
          </Box>
        )}
      </Box>
    </Paper>
  );
}
